import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { getConditionalObject } from 'utils/data';

const getWrapperStyles = ({ isHighlighted }) => ({
  display: 'flex',
  gap: '12px',
  justifyContent: 'space-between',
  padding: '12px',
  border: ({ palette }) =>
    `1px solid ${isHighlighted ? palette.text.tableHighlight : palette.border.default}`,
  borderRadius: ({ shape }) => shape.radius.l,
  overflow: 'hidden',
});

const getTextContentStyles = ({ isHighlighted, isDeleted }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  padding: '1px 4px',
  overflow: 'hidden',

  ...getConditionalObject(isHighlighted, {
    backgroundColor: ({ palette }) => palette.background.tableHighlight,
    borderRadius: ({ shape }) => shape.radius.s,
  }),

  ...getConditionalObject(isDeleted, {
    textDecoration: 'line-through',
    textDecorationColor: ({ palette }) => palette.text.tableHighlight,
  }),
});

const BadgeWrapper = ({ isHighlighted = false, isDeleted = false, control, textContent }) => {
  return (
    <Box sx={getWrapperStyles({ isHighlighted })}>
      <Box
        sx={getTextContentStyles({
          isHighlighted,
          isDeleted,
        })}
      >
        {textContent}
      </Box>

      {control}
    </Box>
  );
};

BadgeWrapper.propTypes = {
  textContent: PropTypes.node.isRequired,
  isHighlighted: PropTypes.bool,
  isDeleted: PropTypes.bool,
  control: PropTypes.node,
};

export default memo(BadgeWrapper);
